'use strict';

const TOGGLE_BTN_SELECTOR = '[data-toggle]';

function toggleEvent(ev) {
    const element = ev.target.closest(TOGGLE_BTN_SELECTOR);

    if (!element) {
        return;
    }
    const targetElement = document.querySelector(element.dataset.toggle);

    if (!targetElement) {
        return;
    }

    const bodyClass = element.dataset.toggleBodyClass;
    const toggleClass = element.dataset.toggleClass || 'is-toggled';

    const iconRef = element.getElementsByTagName('use')[0];
    const toggleIcon = element.dataset.toggleIcon;
    const originalIcon = element.dataset.originalIcon;

    const triggerResize = element.dataset.triggerResize;

    const labelElement = document.querySelector(
        element.dataset.toggleLabelSelector || '.js-toggle__label'
    );

    const focusElement = document.querySelector(element.dataset.toggleFocus);

    const toggleLabel = element.dataset.toggleLabel;
    const isToggled = element.classList.contains(toggleClass);

    const closeElement = document.querySelector(element.dataset.toggleClose);

    if (closeElement && closeElement.classList.contains(toggleClass)) {
        closeElement.click();
        return;
    }

    targetElement.classList.toggle(toggleClass);
    element.classList.toggle(toggleClass);

    element.setAttribute('aria-expanded', isToggled ? 'false' : 'true');
    targetElement.setAttribute('aria-hidden', isToggled ? 'true' : 'false');

    if (toggleIcon && originalIcon) {
        iconRef.setAttribute('xlink:href', isToggled ? '#icon-' + originalIcon : '#icon-' + toggleIcon );
    }

    if (toggleLabel && labelElement) {
        element.dataset.toggleLabel = element.innerHTML;
        labelElement.innerHTML = toggleLabel;
    }

    if (bodyClass) {
        document.body.classList.toggle(bodyClass);
    }

    if (!isToggled && focusElement) {
        focusElement.focus();
    }

    if (triggerResize) {
        window.dispatchEvent(new Event('resize'));
    }
}

function initElement(element) {
    console.log('initElement', element);
    element.addEventListener('click', toggleEvent, false);
}

(function init() {
    initElement(document);
})()
